var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.308715 6.39596L7.64202 11.0626C7.75136 11.1319 7.87601 11.1666 8.00001 11.1666C8.12467 11.1666 8.24867 11.1319 8.35801 11.0626L15.6913 6.39596C15.8833 6.2733 16 6.0613 16 5.8333C16 5.60531 15.8833 5.39331 15.6913 5.27131L8.35798 0.603992C8.13933 0.465336 7.86064 0.465336 7.64198 0.603992L0.308715 5.27131C0.116717 5.39331 6.10414e-05 5.60531 6.10414e-05 5.8333C2.97916e-05 6.0613 0.116717 6.2733 0.308715 6.39596Z",
    fill: "#3F4D55"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6913 11.6042L13.6266 10.2902L9.07401 13.1875C8.75066 13.3921 8.38001 13.5001 8.00001 13.5001C7.62002 13.5001 7.24936 13.3921 6.92802 13.1881L2.37336 10.2902L0.308715 11.6042C0.116717 11.7268 6.10352e-05 11.9388 6.10352e-05 12.1668C6.10352e-05 12.3948 0.116717 12.6068 0.308715 12.7288L7.64202 17.3961C7.75136 17.4655 7.87536 17.5001 8.00001 17.5001C8.12401 17.5001 8.24867 17.4655 8.35801 17.3961L15.6913 12.7288C15.8833 12.6068 15.9999 12.3948 15.9999 12.1668C16 11.9388 15.8833 11.7268 15.6913 11.6042Z",
    fill: "#3F4D55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.fc94fa1ba38387d13f66bd0810d4fc9c.svg";
export { ForwardRef as ReactComponent };